module.exports = __webpack_public_path__ + "img/ico_alarm_off.336b8c04.svg";